<!--
 * @Author: cmchiu
 * @Date: 2022-04-27 12:14:13
 * @LastEditTime: 2022-06-24 15:06:41
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\layout\components\AppMain.vue
 * 
-->
<template>
    <div class="app-main">
        <!-- <breadcrumb /> -->
        <router-view :key="key" />
    </div>
</template>

<script>
// import { breadcrumb } from '@c/Breadcrumb'

export default {
    name: 'AppMain',

    // components: { breadcrumb },

    computed: {
        key() {
            return this.$route.fullPath
        },
    },
}
</script>

<style scoped></style>